import React from "react";
import { FxLabel } from "./FxLabel";

export const FxTextArea = props => {
  const { attr, onChangeValue, fxInObj, inputType } = props;
  const defaultValue = fxInObj[attr.attrName];
  const disabled = attr.readOnlyYn === 'Y';
  const sx = {};

  sx.minHeight = "100px";
  if (attr.uiWidth > 0) {
    sx.minWidth = attr.uiWidth;
    sx.width = attr.uiWidth;
  } else {
    sx.width = '100%';
  }

  function onChange(event) {
    onChangeValue(event.target.id, event.target.value);
  }

  console.log('*** FxTextField ***', inputType, attr.attrName, fxInObj[attr.attrName]);

  return (
    <>
      <FxLabel attr={attr} inputType={inputType} />
      <textarea className="FxTextField  FxTextArea" id={attr.attrName} rows={5} cols={100} style={sx} defaultValue={defaultValue} disabled={disabled}
        onChange={onChange} />
    </>
  );

}

export const FxTextArea2 = props => {
  const { attrClass, para, defaultValue } = props;
  const sx = attrClass.getStyle();

  sx.minHeight = "100px";

  function onChange(event) {
    if (para.onChange) para.onChange(event.target.id, event.target.value);
  }

  return (
    <>
      <textarea className="FxTextField  FxTextArea" id={attrClass.getId()} rows={5} cols={100} style={sx} defaultValue={defaultValue} disabled={attrClass.isDisable()}
        onChange={onChange} />
    </>
  );

}

export const FxTextAreaBase = props => {
  const { onChangeValue, name, className, disabled, width, defaultValue, selectedData} = props;
  const sx = {};

  if (width) {
    sx.minWidth = width;
    sx.width = width;
  } else {
    sx.width = '99%';
  }

  function onChange(event) {
    onChangeValue(event.target.id, event.target.value);
  }

  return (
    <>
      <textarea className={className ? className : "FxTextField"} id={name} rows={5} cols={100} style={sx} defaultValue={defaultValue ? defaultValue : selectedData ? selectedData[name] : ''} disabled={disabled}
        onChange={onChange} />
    </>
  );

}